import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export default function Logo({ light = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2 group ${className}`} data-testid="logo-link">
      <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-blue to-brand-purple flex items-center justify-center shadow-md group-hover:scale-105 transition-transform">
        <GraduationCap className="w-5 h-5 text-white" strokeWidth={2.5} />
      </div>
      <span
        className={`font-heading font-black text-xl tracking-tight ${
          light ? "text-white" : "text-brand-ink"
        }`}
      >
        EDUCAR<span className={light ? "text-brand-yellow" : "text-brand-purple"}>TE</span>
      </span>
    </Link>
  );
}
